import { createFileRoute } from '@tanstack/react-router'

import { PaginaMeusAlertas } from '@/features/meus-alertas/pagina'
import { type BuscaMeusAlertas, lerBuscaMeusAlertas } from '@/features/meus-alertas/periodo'

export const Route = createFileRoute('/$perfil/meus-alertas/')({
  validateSearch: (busca: Record<string, unknown>): BuscaMeusAlertas => lerBuscaMeusAlertas(busca),
  component: Tela,
})

function Tela() {
  const busca = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <PaginaMeusAlertas
      busca={busca}
      aoMudarBusca={(nova) => void navigate({ search: nova, replace: true })}
    />
  )
}
